// As soluções são exibidas na página inicial e estão serpardas em 2 arrays deivido ao número impar de soluções, para que o layou fique centraliado

export const infosolucoes = [
  {
    id: '1',
    img: '/icons/solucoes/SD-Sign.png',
    alt: 'SD Sign',
    title: 'SD Sign',
    description: 'Plataforma de Assinaturas sem limite de usuários.',
  },
  {
    id: '2',
    img: '/icons/solucoes/SD-Doc.png',
    alt: 'SD Doc',
    title: 'SD Doc',
    description: 'GED com assinatura Eletrônica e Digital.',
  },
  {
    id: '3',
    img: '/icons/solucoes/Liveness.png',
    alt: 'Liveness 3D',
    title: 'Liveness 3D',
    description:
      'O mais moderno e seguro mecanismo de assinatura com Prova de Vida.',
  },
  {
    id: '4',
    img: '/icons/solucoes/Crm.png',
    alt: 'SD Crm',
    title: 'SD Crm',
    description:
      'Gestão do funil de vendas e jornada completa do cliente e gestão de projetos.',
  },
]
export const infosolucoes2 = [
  {
    id: '5',
    img: '/icons/solucoes/Sdc.png',
    alt: 'SDC',
    title: 'SDC',
    description:
      'Consulta de crédito, com análise completa sem necessidade de assinatura mensal.',
  },
  {
    id: '6',
    img: '/icons/solucoes/Adquirencia.png',
    alt: 'Adquirência',
    title: 'Adquirência',
    description:
      'Em parceria com a FictorPay, oferecemos solução de pagamentos com as menores taxas do mercado.',
  },
  {
    id: '7',
    img: '/icons/solucoes/Renave.png',
    alt: 'Renave',
    title: 'Renave',
    description:
      'Sistema de comunicação do Renave para concessionárias, revendedoras e implementadoras de veículos.',
  },
]
